export default function AuthServiceProvider() {
  this.$get = ($timeout, $http, $location, vuiLocalStorage, $cookies, $t, $q, $alert, AccountsApi, $recaptcha) => {
    'ngInject';

    function AuthService() {

      const self = this;
      self._user = null;

      self.user = () => {
        return self._user;
      }

      self.currentUser = (callback, reload) => {
        const token = self.getToken();

        if ((token && !self._user) || reload) {
          updateHttp(token);
          AccountsApi.find(data => {
              self._user = data;
              setSentryUserContext(self._user);
              if (callback) {
                callback(data)
              }
            },
            error => {
              deleteToken();
              deleteAdminToken();
              self._user = null;
              setSentryUserContext(self._user);
              $alert.error(extractError(error) || $t('shared.auth.session_expired_error_message'));
            });
        } else {
          if (callback) {
            $timeout(() => callback(self._user));
          }
        }
      };

      const setSentryUserContext = user => {
        try {
          if (user) {
            // TODO need to pay
            /*Sentry.setUser({
                id: user.id,
                email: user.email,
                name: user.name + " " + user.surname
            });*/
          }/* else {
                    Sentry.configureScope(scope => scope.clear())
                }*/
        } catch (e) {
          console.error(e.stack);
        }
      };

      const authorize = (code, redirectLink, authorization, callback) => {
        if (!code) {
          $alert.warning($t('shared.auth.unable_to_login_error_message'));
        } else {
          const data = new FormData();
          data.append('code', code);
          const config = {
            headers: {
              'Content-Type': undefined,
              'Authorization': authorization
            }
          };
          $http.post('/api/v1/oauth2/token?scope=back_office&grant_type=exchange_code', data, config)
            .then(response => {
              const token = response.data;
              token.authorization = authorization;
              setToken(token);
              self.currentUser(user => {
                if (typeof redirectLink === 'string' && redirectLink) {
                  const fullyDecodeURI = fullyDecodeURIComponent(redirectLink);
                  $location.url(fullyDecodeURI);
                } else {
                  if (user.role === 'USER') {
                    if (self.isActivatedUser()) {
                      $location.path('/bicycle-owner/service-bookings').search({});
                    } else {
                      $location.path('/bicycle-owner/complete-registration').search({});
                    }
                  } else if (self.isBikeOrganisationOwner()) {
                    $location.path('/organisations').search({});
                  } else if (self.isMechanic()) {
                    if (self._user.verificationLevel && self._user.verificationLevel !== 'NONE') {
                      $location.path('/service-provider/service-bookings').search({});
                    } else if (!self._user.mechanicCategory && self._user.appliedForCategory) {
                      if (self._user.appliedForCategory === 'INDIVIDUAL') {
                        $location.path('/service-provider/verification/individual').search({});
                      } else if (self._user.appliedForCategory === 'MOBILE') {
                        $location.path('/service-provider/verification/mobile-shop').search({});
                      } else if (self._user.appliedForCategory === 'SHOP') {
                        $location.path('/service-provider/verification/bicycle-shop').search({});
                      } else {
                        $location.path('/service-provider/verification/type').search({});
                      }
                    } else {
                      $location.path('/service-provider/verification/type').search({});
                    }
                  } else {
                    $location.path('/admin/users').search({});
                  }
                }

                if (callback) {
                  callback()
                }
              });
            })
            .catch(() => {
              $alert.warning($t('shared.auth.unable_to_login_error_message'));
              restoreAndDeleteBackupToken()
            });
        }
      };

      const fullyDecodeURIComponent = (value) => {
        let prev;
        let current = value;

        do {
          prev = current;
          current = decodeURIComponent(current);
        } while (current !== prev);

        return current;
      }

      const authorizeUser = (code, redirectLink, callback) => {
        const authorization = 'Basic ' + process.env.USER_AUTH_CREDENTIALS;
        authorize(code, redirectLink, authorization, callback)
      }

      self.authorizeWithCode = (code, redirectLink) => {
        const authorization = 'Basic ' + process.env.ADMIN_AUTH_CREDENTIALS;
        authorize(code, redirectLink, authorization)
      }

      self.activation = (activationToken, successCallback, errorCallback) => {
        vuiLocalStorage.remove('x-token');
        AccountsApi.confirmRegistration({activationToken: activationToken}, {},
          response => {
            authorizeUser(response.token, null, (data) => {
              if (successCallback) {
                successCallback(data);
              }
            });
          },
          error => {
            $alert.error(extractError(error) || $t('shared.auth.activation_account_error_message'));
            if (errorCallback) {
              errorCallback(error);
            }
            $location.path('/');
          });
      };

      self.activateBusinessAccount = (activateAccount, activationToken, psswd, redirect) => {
        activateAccount({token: activationToken}, psswd, response => {
            if (redirect && response.organisationId) {
              redirect = redirect.replaceAll(":orgId", response.organisationId);
            }

            authorizeUser(response.token, redirect, _ =>
              $alert.success($t('shared.auth.activation_account_success_message')));
          },
          error => $alert.error(extractError(error) || $t('shared.auth.activation_account_error_message')));
      };

      self.cancelActivation = (cancelRegistration, cancelToken, successCallback, errorCallback) => {
        cancelRegistration({token: cancelToken}, {},
          () => {
            $alert.warning($t('shared.auth.activation_account_cancelled_message'));
            $location.search({});
            $location.path('/');
            if (successCallback) {
              successCallback();
            }
          },
          error => {
            $location.search({});
            $location.path('/');
            $alert.error(extractError(error) || $t('shared.auth.activation_account_error_message'));
            if (errorCallback) {
              errorCallback(error);
            }
          });
        const token = self.getToken();
        if (token !== null) {
          deleteToken();
        }
      };

      self.login = (email, password, redirect, callback) => {
        const authHeader = 'Basic ' + process.env.USER_AUTH_CREDENTIALS;
        const data = new FormData();
        data.append('username', email);
        data.append('password', password);
        authorisation(data, 'default_password', authHeader)
          .then(response => {
            const data = response.data;
            data.authorization = authHeader;
            setToken(data);
            if (callback) {
              callback();
            }
            self.currentUser(_ => {
              if (redirect) {
                const fullyDecodeURI = fullyDecodeURIComponent(redirect);
                if (isAbsoluteUrl(fullyDecodeURI)) {
                  window.location = fullyDecodeURI;
                } else {
                  $location.url(fullyDecodeURI);
                }
              } else if (self.isPartiallyRegistered()) {
                $location.path('/complete-social-registration').search({});
              } else {
                if (self.isUser()) {
                  if (self.isActivatedUser()) {
                    $location.path('/bicycle-owner/service-bookings').search({});
                  } else {
                    $location.path('/bicycle-owner/complete-registration').search({});
                  }
                } else if (self.isBikeOrganisationOwner()) {
                  $location.path('/organisations').search({});
                } else if (self.isMechanic()) {
                  if (self._user.verificationLevel && self._user.verificationLevel !== 'NONE') {
                    $location.path('/service-provider/service-bookings').search({});
                  } else if (!self._user.mechanicCategory && self._user.appliedForCategory) {
                    if (self._user.appliedForCategory === 'INDIVIDUAL') {
                      $location.path('/service-provider/verification/individual').search({});
                    } else if (self._user.appliedForCategory === 'MOBILE') {
                      $location.path('/service-provider/verification/mobile-shop').search({});
                    } else if (self._user.appliedForCategory === 'SHOP') {
                      $location.path('/service-provider/verification/bicycle-shop').search({});
                    } else {
                      $location.path('/service-provider/verification/type').search({});
                    }
                  } else {
                    $location.path('/service-provider/verification/type').search({});
                  }
                } else {
                  $location.path('/admin/users').search({});
                }
              }
            }, true);
          })
          .catch((error, _) => {
            $alert.error(extractError(error) || $t('shared.auth.incorrect_credentials_error_message'));
            if (callback) {
              callback();
            }
          });
      };

      self.refreshToken = (successCallback, errorCallback) => {
        const token = self.getToken();
        const authHeader = token.authorization ? token.authorization : 'Basic ' + process.env.USER_AUTH_CREDENTIALS;
        const refreshToken = token.refresh_token ? token.refresh_token : token;
        const data = new FormData();
        data.append('refresh_token', refreshToken);
        authorisation(data, 'refresh_token', authHeader)
          .then(response => {
            const data = response.data;
            data.authorization = authHeader;
            setToken(data);
            if (successCallback) {
              successCallback(data);
            }
          })
          .catch((response, _) => {
            deleteToken()
            deleteAdminToken()
            if (errorCallback) {
              errorCallback(response);
            }
          });
      };

      const authorisation = (request, grantType, authHeader) => $http
        .post('/api/v1/oauth2/token?scope=back_office&grant_type=' + grantType, request, getAuthConfig(authHeader));

      const isAbsoluteUrl = url => {
        const pat = /^https?:\/\//i;
        return pat.test(url);
      };

      self.logout = (isNonRedirect, callback) => {
        const fullLogoutCallback = () => {
          deleteToken();
          deleteAdminToken();

          self._user = null;
          if (isNonRedirect !== true) {
            $timeout(() => {
              $location.path('/');
            }, 0);
          }
          if (callback) {
            callback();
          }
        }

        const logoutCallback = () => {
          if (hasAdminToken()) {
            const adminToken = getAdminToken();
            const revokeRequest = new FormData();
            revokeRequest.append('token', adminToken.refresh_token);

            $http.post('/api/v1/oauth2/revoke', revokeRequest, getAuthConfig(adminToken.authorization))
              .then(fullLogoutCallback)
              .catch(fullLogoutCallback);
          } else {
            fullLogoutCallback()
          }
        };

        const token = self.getToken();
        if (token) {
          const revokeRequest = new FormData();
          revokeRequest.append('token', token.refresh_token);

          $http.post('/api/v1/oauth2/revoke', revokeRequest, getAuthConfig(token.authorization))
            .then(logoutCallback)
            .catch(logoutCallback);
        } else {
          fullLogoutCallback()
        }
      };

      const getAuthConfig = (authorization) => {
        return {
          headers: {
            'Content-Type': undefined,
            'Authorization': authorization
          }
        };
      }

      self.logoutToAdmin = redirectPath => {
        const logoutToAdminCallback = () => {
          restoreAndDeleteBackupToken(() => {
            self._user = null;
            if (redirectPath) {
              $location.url(redirectPath);
            } else {
              $location.url("/dashboard");
            }
          });
        }

        const token = self.getToken();
        const revokeRequest = new FormData();
        revokeRequest.append('token', token.refresh_token);

        $http.post('/api/v1/oauth2/revoke', revokeRequest, getAuthConfig(token.authorization))
          .then(logoutToAdminCallback)
          .catch(logoutToAdminCallback);
      };

      self.signUp = (signUp, scope, successCallback, errorCallback) => {
        const errorHandler = error => {
          $alert.error(extractError(error) || $t('shared.auth.sign_up_error_message'));
          delete scope.registration.user.repeatPassword;
          delete scope.registration.user.password;
          scope.registration.disabledUser = false;
          if (errorCallback) {
            errorCallback(error);
          }
        };

        $recaptcha.execute('sign_up', token => {
          const user = {
            name: scope.registration.user.name,
            surname: scope.registration.user.surname,
            email: scope.registration.user.email,
            phone: scope.registration.user.phone,
            password: scope.registration.user.password,
            gRecaptchaResponse: token,
            gRecaptchaAction: "sign_up"
          };
          signUp(user, response => {
            authorizeUser(response.token, null, () => {
              self.currentUser(user => {
                if (self.isPartiallyRegistered()) {
                  $location.path('/complete-social-registration').search({});
                } else if (self.isUser() && !user.activated) {
                  $alert.warning($t('shared.auth.need_to_activate_message'));
                  $location.path('/bicycle-owner/complete-registration').search({});
                } else {
                  $location.path('/bicycle-owner/service-bookings').search({});
                }
              }, true);
            });
            scope.registration.disabledUser = false;
            if (successCallback) {
              successCallback(response);
            }
          }, errorHandler);
        }, errorHandler);
      };

      self.joinVelotooler = (signUp, scope, successCallback, errorCallback) => {
        $recaptcha.execute('sign_up', token => {
          const user = {
            name: scope.registration.mechanic.name,
            surname: scope.registration.mechanic.surname,
            address: {address: scope.registration.mechanic.address},
            phone: scope.registration.mechanic.phone,
            email: scope.registration.mechanic.email,
            password: scope.registration.mechanic.password,
            mechanicCategory: scope.registration.mechanic.mechanicCategory,
            gRecaptchaResponse: token,
            gRecaptchaAction: "sign_up"
          };
          const verificationSearch = user.mechanicCategory === 'MOBILE' || user.mechanicCategory === 'SHOP'
            ? {askAssaciation: true}
            : {};
          signUp(user, response => {
              authorizeUser(response.token, null, () => {
                self.currentUser(user => {
                  if (self.isPartiallyRegistered()) {
                    $location.path('/complete-social-registration').search({});
                  } else if (!user.activated) {
                    $alert.warning($t('shared.auth.need_to_activate_message'));
                    $location.path('/service-provider/verification/type').search(verificationSearch);
                  } else {
                    $location.path('/service-provider/verification/type').search(verificationSearch);
                  }
                }, true);
              });
              scope.registration.disabledMechanic = false;
              if (successCallback) {
                successCallback(response);
              }
            },
            error => {
              $alert.error(extractError(error) || $t('shared.auth.activation_account_error_message'));
              delete scope.registration.mechanic.repeatPassword;
              delete scope.registration.mechanic.password;
              scope.registration.disabledMechanic = false;
              if (errorCallback) {
                errorCallback(error);
              }
            });
        });
      };

      self.completeSocialRegistration = (confirmRegistration, code, data, callback) => {
        confirmRegistration({token: code}, data, () => {
          authorizeUser(code, null, () => {
            if (callback) {
              callback()
            }
          });
        });
      };

      self.refreshAuthentication = () => {
        const deferred = $q.defer();
        const currentToken = self.getToken();
        const newToken = $location.search().accessToken || currentToken;
        $location.search('accessToken', null);
        if (newToken) {
          setToken(newToken);
        }
        self.currentUser(user => {
          deferred.resolve(user);
        }, newToken && newToken !== currentToken);
        return deferred.promise;
      };

      self.updateUser = data => {
        self._user.name = self._user.name || "";
        self._user.surname = self._user.surname || "";
        for (const p in data) {
          if (p in self._user) {
            self._user[p] = data[p];
          }
        }
      };

      self.isLogin = () => !!self.getToken();

      self.isAdmin = () => self.isLogin() && self._user && self._user.role === 'ADMIN';

      self.isMechanic = () => self.isLogin() && self._user && self._user.role === 'MECHANIC';

      self.isVerifiedMechanic = () => self.isMechanic() && (self._user.verified === true);

      self.isIndividualMechanic = () => self.isVerifiedMechanic() && (self._user.mechanicCategory === 'INDIVIDUAL');

      self.isMobileShop = () => self.isVerifiedMechanic() && (self._user.mechanicCategory === 'MOBILE');

      self.isBicycleShop = () => self.isVerifiedMechanic() && (self._user.mechanicCategory === 'SHOP');

      self.isUser = () => self.isLogin() && self._user && self._user.role === 'USER';

      self.isActivatedUser = () => (self.isUser() && self._user.activated) || self.isLogoutToAdminAvailable();

      self.isPartiallyRegistered = () => self.isLogin() && self._user && self._user.role === 'PARTIALLY_REGISTERED';

      self.isFullyLoggedIn = () => self.isLogin() && self._user && self._user.role !== 'PARTIALLY_REGISTERED';

      self.isBikeOrganisationOwner = () => self.isLogin() && self._user && self._user.role === 'BIKE_ORGANIZATION_OWNER';

      self.isLogoutToAdminAvailable = () => !!getAdminToken();

      self.getToken = () => {
        let token = vuiLocalStorage.get('x-token');

        if (!token) {
          token = $cookies.get('x-token');
        }

        return token;
      };

      const getAdminToken = () => {
        let token = vuiLocalStorage.get('x-admin-token');

        if (!token) {
          token = $cookies.get('x-admin-token');
        }

        return token;
      };

      const hasAdminToken = () => !!getAdminToken();

      const setToken = token => {
        try {
          vuiLocalStorage.put('x-token', token);
        } catch (e) {
          $cookies.put('x-token', token);
        }
        updateHttp(token);

        return token;
      };

      const setAdminToken = token => {
        try {
          vuiLocalStorage.put('x-admin-token', token);
        } catch (e) {
          $cookies.put('x-admin-token', token);
        }

        return token;
      };

      self.backupAndDeleteToken = callback => {
        const token = self.getToken();
        setAdminToken(token);
        deleteToken();
        self._user = null;
        if (callback) {
          callback();
        }
      };

      const restoreAndDeleteBackupToken = callback => {
        const token = getAdminToken();
        setToken(token);
        deleteAdminToken();
        self._user = null;
        if (callback) {
          callback();
        }
      };

      const deleteToken = () => {
        try {
          vuiLocalStorage.remove('x-token');
          $cookies.remove('x-token');
        } catch (e) {
          $cookies.remove('x-token');
        }

        updateHttp(undefined);
      };

      const deleteAdminToken = () => {
        try {
          vuiLocalStorage.remove('x-admin-token');
          $cookies.remove('x-admin-token');
        } catch (e) {
          $cookies.remove('x-admin-token');
        }
      };

      const updateHttp = token => {
        if (token) {
          $http.defaults.headers.common['Authorization'] = token.token_type + ' ' + token.access_token;
        } else {
          delete $http.defaults.headers.common['Authorization'];
        }
      };

      const extractError = error => error && error.data ? error.data.message : undefined;

    }

    return new AuthService();
  };
}